import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface GetFlashMessageRequest extends APIRequest
{
    getMsisdn(): string;
}

export class GetFlashMessageRequestImpl extends APIRequestDtoImpl implements GetFlashMessageRequest
{
    constructor(private msisdn: string)
    {
        super();
    }
    getMsisdn(): string {
       return this.msisdn;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/getflashmessages/getflashmessagesrequest.tsx